import { cva, VariantProps } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';
import { InputState, TextInputTypes } from '../../../util/types';
import { commonVariants } from '../styles.ts';
import { forwardRef } from 'react';

export interface TextInputAtomProps extends React.InputHTMLAttributes<HTMLInputElement> {
  state?: InputState;
  type?: TextInputTypes;
}

const inputVariants = cva(
  [
    'preflight',
    'ds-form-input',
    'ds-h-[40px]',
    'ds-rounded',
    'ds-p-2',
    '!ds-border',
    '!ds-font-sans',
    'ds-container'
  ],
  commonVariants
);

interface InputVariants extends VariantProps<typeof inputVariants> {}
const input = (variants: InputVariants) => twMerge(inputVariants(variants));

const TextInputAtom = forwardRef(
  (
    {
      state = 'default' as InputState,
      disabled = false,
      type = 'text' as TextInputTypes,
      ...props
    }: TextInputAtomProps,
    ref: React.Ref<HTMLInputElement>
  ) => {
    return (
      <input
        aria-disabled={disabled}
        readOnly={disabled}
        type={type}
        className={input({ disabled, state })}
        ref={ref}
        {...props}
      />
    );
  }
);

export default TextInputAtom;
